module.exports = __webpack_public_path__ + "static/media/ktm-10.db3491e3.jpg";